import {
  ErrorHandler,
  inject,
  Injectable,
} from '@angular/core';
import { ChunkRecoveryService } from './chunk-recovery';

@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  private readonly defaultErrorHandler = new ErrorHandler();
  private readonly recovery = inject(ChunkRecoveryService);

  handleError(error: unknown): void {
    if (!this.recovery.scheduleGlobalRecovery(error)) {
      this.defaultErrorHandler.handleError(error);
    }
  }
}
